import Marquee from "react-fast-marquee";

const WORDS = ["Tandoor", "Biryani", "Cocktails", "Curries", "Chaat", "Desserts", "Kebabs"];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="relative bg-[#0D0D0D] py-16 md:py-24 border-y border-[#C8A24A]/10 overflow-hidden">
      <Marquee gradient={false} speed={45} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-6xl md:text-8xl lg:text-9xl text-stroke-gold px-8 select-none">
              {w}
            </span>
            <span className="text-[#C8A24A] text-4xl md:text-6xl px-4">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
